import React, { FC, ReactNode } from 'react'
import { Card, Typography, Divider } from 'antd'

const { Title, Text } = Typography

interface PageProps {
	children?: React.ReactChild[] | React.ReactChild
	divider?: boolean
	title?: ReactNode
	subtitle?: string
	titleLevel?: 1 | 2 | 3 | 4
}

const Page: FC<PageProps> = ({ title, titleLevel, subtitle, divider, children }) => {
	const baseTitleNode = (
		<Title level={titleLevel || 1}>
			{title} {subtitle && <Text type='secondary'>{subtitle}</Text>}
		</Title>
	)
	const titleNode = title && (typeof title !== 'string' ? title : baseTitleNode)

	return (
		<Card bordered={false}>
			{titleNode}
			{divider && <Divider />}
			{children && children}
		</Card>
	)
}

export default Page
